import { useState } from 'react';
import { Send } from 'lucide-react';
import { Card, CardContent } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { DispatchesFilters } from '@/components/dispatches/DispatchesFilters';
import { DispatchesTable } from '@/components/dispatches/DispatchesTable';
import { DispatchDetailDialog } from '@/components/dispatches/DispatchDetailDialog';
import { QuickSendDialog } from '@/components/dispatches/QuickSendDialog';
import { ExportButton } from '@/components/dispatches/ExportButton';
import type { DispatchFilters } from '@/hooks/useDispatches';
import type { Dispatch } from '@/types/api.types';

export function DispatchesPage() {
  const [filters, setFilters] = useState<DispatchFilters>({ page: 1 });
  const [selectedDispatch, setSelectedDispatch] = useState<Dispatch | null>(null);
  const [quickSendOpen, setQuickSendOpen] = useState(false);

  function handleFiltersChange(newFilters: DispatchFilters) {
    setFilters({ ...newFilters, page: 1 });
  }

  function handlePageChange(page: number) {
    setFilters((f) => ({ ...f, page }));
  }

  return (
    <div className="space-y-4">
      <div className="flex items-center justify-between">
        <div>
          <h1 className="text-2xl font-semibold">Disparos</h1>
          <p className="mt-1 text-sm text-muted-foreground">
            Monitore todos os disparos da sua conta
          </p>
        </div>
        <div className="flex items-center gap-2">
          <ExportButton filters={filters} />
          <Button onClick={() => setQuickSendOpen(true)}>
            <Send className="h-4 w-4 mr-2" />
            Envio rápido
          </Button>
        </div>
      </div>

      <Card>
        <CardContent className="space-y-4 pt-4">
          <DispatchesFilters filters={filters} onChange={handleFiltersChange} />
          <DispatchesTable
            filters={filters}
            onPageChange={handlePageChange}
            onViewDetail={setSelectedDispatch}
          />
        </CardContent>
      </Card>

      <DispatchDetailDialog
        dispatch={selectedDispatch}
        onOpenChange={(open) => {
          if (!open) setSelectedDispatch(null);
        }}
      />

      <QuickSendDialog open={quickSendOpen} onOpenChange={setQuickSendOpen} />
    </div>
  );
}
